var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "input input--single",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "input__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    staticClass: "input__input inp-subtle"
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s((_vm.model || '') + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "input__input__textarea",
    attrs: {
      "autofocus": !_vm.model,
      "type": "text"
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "focus": function($event) {
        _vm.focus = 1
      },
      "blur": function($event) {
        _vm.focus = 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1b427a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSingle.vue
// module id = 94
// module chunks = 1